"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeNullishKeys = exports.fillWithXByArrayDef = exports.fillWIthX = exports.getObjectTypeSummary = exports.smashObjects = exports.updateNonNullishValues = exports.getContainedPopulatedKeys = exports.getContainedKeys = exports.Assembler = exports.removeEmptyArrays = exports.safeJSON = exports.flattenArray = exports.flattenObject = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const BusinessObjectAssembler_1 = require("../../BusinessObjectAssembler");
// this will knowingly over write keys of same name at higher levels !
const flattenObject = (ob, filteredKeys) => {
    const map = {};
    ob &&
        Object.entries(ob).forEach(([k, v]) => {
            if (v && typeof v === 'object') {
                Object.assign(map, (0, exports.flattenObject)(v, filteredKeys));
            }
            else if (!filteredKeys || filteredKeys.includes(k)) {
                map[k] = v;
            }
        });
    return map;
};
exports.flattenObject = flattenObject;
const flattenArray = (arr) => arr.reduce((a, c) => {
    if (c instanceof Array) {
        a = [...a, ...(0, exports.flattenArray)(c)];
    }
    else {
        a = [...a, c];
    }
    return a;
}, []);
exports.flattenArray = flattenArray;
exports.safeJSON = {
    parse: (obstr) => {
        let res = undefined;
        if (typeof obstr === 'string') {
            try {
                res = JSON.parse(obstr);
            }
            catch (e) {
                console.log('safeJSON caught parse error on probably not JSON string', obstr);
            }
        }
        return res;
    },
};
const removeEmptyArrays = (vob) => {
    Object.keys(vob).forEach((k) => {
        if (vob[k] instanceof Array && vob[k].length === 0) {
            delete vob.k;
        }
    });
};
exports.removeEmptyArrays = removeEmptyArrays;
exports.Assembler = new BusinessObjectAssembler_1.BusinessObjectAssembler();
const getContainedKeys = (anyObjects) => {
    const containedKeys = anyObjects.reduce((acc, curr) => {
        Object.keys(curr).forEach((k) => {
            if (!acc.includes(k)) {
                acc.push(k);
            }
        });
        return acc;
    }, []);
    return containedKeys;
};
exports.getContainedKeys = getContainedKeys;
const getContainedPopulatedKeys = (anyObjects) => {
    const containedKeys = anyObjects.reduce((acc, curr) => {
        Object.entries(curr).forEach(([k, v]) => {
            if ((v || v === 0 || v === false) && !acc.includes(k)) {
                acc.push(k);
            }
        });
        return acc;
    }, []);
    return containedKeys;
};
exports.getContainedPopulatedKeys = getContainedPopulatedKeys;
/** updates like Object.assign but ignores null, NaN, undefined, used for example in updating a key that is return only in some device messages  */
const updateNonNullishValues = (ob, update) => {
    Object.entries(update).forEach(([k, v]) => {
        if (v || v === 0 || v === false) {
            ;
            ob[k] = v;
        }
    });
    return ob;
};
exports.updateNonNullishValues = updateNonNullishValues;
/**
 * @function smashObjects returns an object with keys as the union of all keys in anyObject and the first defined value for each key
 * This is used to generate ViewDefinitions for untyped, and unpredicable object lists
 * @param anyObjects
 * @returns
 */
const smashObjects = (anyObjects) => {
    let smashed = {};
    anyObjects.forEach((o) => {
        Object.entries(o).forEach(([k, v]) => {
            if (!smashed[k] && v !== undefined && v !== null) {
                smashed[k] = v;
            }
        });
    });
    return smashed;
};
exports.smashObjects = smashObjects;
const getObjectTypeSummary = (anyObjects, key = 'type') => {
    const res = {};
    anyObjects.forEach((object) => {
        if (object[key]) {
            if (!res[object[key]]) {
                res[object[key]] = 1;
            }
            else {
                res[object[key]] = res[object[key]] + 1;
            }
        }
    });
    return res;
};
exports.getObjectTypeSummary = getObjectTypeSummary;
/**
 * @function fillWIthX Fills array of n with result of function xFn
 * @param arr
 * @param xFn
 * @returns Array filled with result of xFn
 */
const fillWIthX = (arr, xFn) => {
    for (let i = 0; i < arr.length; i++) {
        arr[i] = xFn();
    }
    return arr;
};
exports.fillWIthX = fillWIthX;
/**
 * @function fillWithXByArrayDef returns a nested array with lengths as per definition with inner array populated by return of xFn. Array lengths in definition must be valid eg integers
 * depth is arbitrary but limited to 10 from type point of view otherwise compiler hits depth issues
 * @param arrDef
 * @param xFn
 * @returns
 */
const fillWithXByArrayDef = (arrDef, xFn) => arrDef.reduceRight((aFn, cN, i) => () => (0, exports.fillWIthX)(new Array(cN), aFn), xFn);
exports.fillWithXByArrayDef = fillWithXByArrayDef;
/** removes null or undefined keys from object so that local objects can be compared to retieved objects, usually in tests */
const removeNullishKeys = (item) => Object.fromEntries(Object.entries(item).filter(([k, v]) => !(0, iotv_v3_types_1.isNullish)(v)));
exports.removeNullishKeys = removeNullishKeys;
